import { Injectable } from "@angular/core";
import { Apollo } from "apollo-angular";
import { Observable, map, take } from "rxjs";
import { ApolloInstances } from "../../graphql.module";
import GET_MEMBER_RECRUITING_DOWNLOAD from '../queries/get-member-recruiting-download';

@Injectable({
    providedIn: 'root',
})
export class RecruitmentGraphqlService {
    constructor(private apollo: Apollo) { }

    getMemberRecruitingDownload(
        memberId: number
    ): Observable<RecruitmentDownload> {

        return this.apollo
            .use(ApolloInstances.RECRUITING)
            .query<{ memberRecruitingDownload: RecruitmentDownload }>({
                fetchPolicy: 'no-cache',
                variables: {
                    memberId
                },
                query: GET_MEMBER_RECRUITING_DOWNLOAD,
            })
            .pipe(
                map(response => response.data.memberRecruitingDownload),
                take(1),
            );
    }
}

export interface RecruitmentDownload {
    url: string;
}